// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__vUBvD","content":"RecentSearches_content__3ELo_"};